
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Head from "next/head"

import SEO from "@/meta/SEO"
import { getHelpCenterArticleProps } from "@/organisms/HelpCenterArticle/functions/getHelpCenterArticleProps"
import HelpCenterArticle from "@/organisms/HelpCenterArticle/HelpCenterArticle"
import Help from "@/templates/Help/Help"

function VouchersHelpPage() {
  const sectionsList = [
    ["using_discount"],
    ["discounted_products", "mailto:info@fansi.pl"],
    ["getting_discount_code", "https://fansi.pl"],
    ["discount_value", "mailto:info@fansi.pl"],
    ["discount_expiry_date", "mailto:info@fansi.pl"],
    ["multiple_discounts"],
    ["using_on_discounted_products"],
  ]

  const { title, output, sections } = getHelpCenterArticleProps(
    "help_discounts",
    "page_heading",
    sectionsList
  )

  return (
    <>
      <Head>
        <title>Centrum pomocy | fansi.pl</title>
        <SEO description="W Centrum Pomocy znajdziesz odpowiedzi na najczęściej zadawane pytania dotyczące platformy fansi, logowania oraz zakupu produktów od influencerów." />
        {/* <meta name="robots" content="noindex,nofollow" /> */}
      </Head>
      <HelpCenterArticle {...{ title, output, sections }} />
    </>
  )
}
VouchersHelpPage.Layout = Help
export default VouchersHelpPage


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/help/discounts',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  